import React, { useState } from "react";
import Events from "../../events.tsx";
import { BroadcastModal } from "../agents/broadcastmodal.jsx";
import BackModule from "./back.tsx";

// Client Dashboard – Kurs & Events (Mirrors agent event listings)
// Supports: Create events on behalf of agents, social publishing, Blaze calendar flags

interface EventItem {
    id: number;
    title: string;
    description: string;
    date: string;
    agent: string;
    link: string;
    publishSocial: boolean;
    publishBlazeCalendar: boolean;
}
type KursAndEventerModuleProps = {
    currentUser: any,
    onLogout: () => void,
    baseUrl: string,
    onLoginClick: () => void,
    onLoginSuccess: () => void,
    selectedEvent: any,
    setSelectedEvent: (ev: any) => void,
    setTab: (tab: string) => void,
}
const KursAndEventerModule = ({ currentUser, onLogout, baseUrl, onLoginClick, onLoginSuccess, selectedEvent, setSelectedEvent, setTab }: KursAndEventerModuleProps) => {
    const [showBroadcastModal, setShowBroadcastModal] = useState(false);
    const showBackBtn = localStorage.getItem("previousPage") ? true : false;

    return (
        <div className="min-h-screen bg-slate-50 px-4 py-8 sm:px-6 lg:px-10">
            {showBackBtn && (
                <BackModule setTab={setTab} label={localStorage.getItem("previousPage") || ""} />
            )}
            <div className="max-w-6xl mx-auto flex flex-col gap-6">
                {/* HEADER */}
                <header className="flex flex-col gap-1">
                    <p className="text-xs font-semibold uppercase tracking-[0.18em] text-sky-600">
                        Teletorget · Client Dashboard
                    </p>
                    <h1 className="text-2xl font-semibold text-slate-900 sm:text-3xl">
                        Kurs &amp; Eventer
                    </h1>
                    <p className="text-sm text-slate-500 max-w-xl">
                        Administrer kurs, streaming‑eventer og kommende arrangementer. Opprett
                        nye eventer på vegne av agenter og publiser direkte til sosial media
                        og Blaze‑kalender.
                    </p>
                </header>

                {/* CREATE NEW EVENT BUTTON */}
                <div>
                    <button
                        onClick={() => setShowBroadcastModal(true)}
                        className="rounded-xl bg-sky-600 text-white text-sm font-semibold px-4 py-2 shadow-sm hover:bg-sky-700"
                    >
                        + Opprett nytt event
                    </button>
                </div>

                {/* EVENT LISTING */}
                <section className="mt-6">
                    <Events currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl} onLoginClick={onLoginClick} onLoginSuccess={onLoginSuccess} selectedEvent={selectedEvent} setSelectedEvent={setSelectedEvent} />
                </section>
            </div>
            <BroadcastModal
                show={showBroadcastModal}
                onClose={() => setShowBroadcastModal(false)}
                baseUrl={baseUrl}
                currentUser={currentUser}
            />
        </div>
    );
};

export default KursAndEventerModule;
